import { Box, Button, MenuItem, Select } from "@mui/material";
import { useState, useEffect } from "react";
import { useRemindMeContext } from "../../context/RemindMeContext";

interface BottomSendContainerProps {
    handleSend: (selectedEmail: string) => void;
    isSendEnabled: boolean;
}

const BottomSendContainer: React.FC<BottomSendContainerProps> = ({
    handleSend,
    isSendEnabled
}) => {
    const [emailOptions, setEmailOptions] = useState<{ label: string, value: string }[]>([]);
    const { selectedEmail, updateEmail } = useRemindMeContext();

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                const savedEmails = localStorage.getItem('emails');
                const defaultEmail = localStorage.getItem('defaultEmail');

                if (savedEmails) {
                    const emailList = JSON.parse(savedEmails);
                    const formattedEmailOptions = emailList.map((email: string) => ({
                        label: email,
                        value: email,
                    }));
                    setEmailOptions(formattedEmailOptions);

                    if (formattedEmailOptions.length !== 0) {
                        if (defaultEmail && emailList.includes(defaultEmail)) {
                            updateEmail(defaultEmail);
                        } else {
                            updateEmail(formattedEmailOptions[0].value);
                        }
                    }
                }
            } catch (error) {
                console.error('Failed to fetch emails:', error);
            }
        };

        fetchEmails();
    }, [updateEmail]);

    return (
        <Box sx={{ mt: 'auto', justifyContent: "center", mb: 2, width: '100%', mx: 'auto' }} >
            <Select
                value={selectedEmail}
                onChange={(e) => updateEmail(e.target.value)}
                fullWidth
                variant="outlined"
                sx={{
                    mb: 2,
                    borderRadius: '25px',
                    '& .MuiMenuItem-root': {
                        textDecoration: 'none',
                    },
                }}
            >
                {emailOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value} sx={{
                        textDecoration: 'none',
                    }}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            <Button
                fullWidth
                variant="contained"
                disabled={!isSendEnabled}
                onClick={async () => {
                    // Call the handleSend method passed from the parent
                    await handleSend(selectedEmail);
                }}
                sx={(theme) => ({
                    mb: 4,
                    py: 1.5,
                    borderRadius: '25px',
                    textTransform: 'uppercase',
                    backgroundColor: theme.palette.primary.main,
                })}
            >
                Send
            </Button>
        </Box >
    )

}

export default BottomSendContainer;